
import Bow from "./Bow.png";
import Changeling from "./Changeling.png";
import CharmBracelet from "./CharmBracelet.png";
import Dawn from "./Dawn.png";
import Day from "./Day.png";
import Dream from "./Dream.png";
import Dusk from "./Dusk.png";
import Eyes from "./Eyes.png";
import Knife from "./Knife.png";
import Light from "./Light.png";
import Night from "./Night.png";
import Ribbon from "./Ribbon.png";
import Shadow from "./Shadow.png";
import Sword from "./Sword.png";
import Teacher from "./Teacher.png";
import Triton from "./Triton.png";
import Twins from "./Twins.png";
import Wand from "./Wand.png";

import Canyon from "./Canyon.png";
import Forest from "./Forest.png";
import Island from "./Island.png";
import Mountain from "./Mountain.png";
import River from "./River.png";
import Swamp from "./Swamp.png";
import Valley from "./Valley.png";

import Deck from "./Deck.png";

import Earth from "./Earth.png";
import Air from "./Air.png";
import Fire from "./Fire.png";
import Water from "./Water.png";

import Storm from "./Storm.png";
import Blizzard from "./Blizzard.png";

import Winter from "./Winter.png";
import Spring from "./Spring.png";
import Summer from "./Summer.png";
import Fall from "./Fall.png";

import Good from "./Good.png";
import Evil from "./Evil.png";
import Law from "./Law.png";
import Chaos from "./Chaos.png";

export const MY_DECK_OF_MANY_MORE_THINGS_URLS = [
  Bow,
  Changeling,
  CharmBracelet,
  Dawn,
  Day,
  Dream,
  Dusk,
  Eyes,
  Knife,
  Light,
  Night,
  Ribbon,
  Shadow,
  Sword,
  Teacher,
  Triton,
  Twins,
  Wand,
  Canyon,
  Forest,
  Island,
  Mountain,
  River,
  Swamp,
  Valley,
  Deck,
  Earth,
  Air,
  Fire,
  Water,
  Storm,
  Blizzard,
  Winter,
  Spring,
  Summer,
  Fall,
  Good,
  Evil,
  Law,
  Chaos,
];
  
// NAME FONT INFO:
// Goudy Old Style, 24px #A1875F